const items = document.querySelector('.ticker__items');
const links = document.querySelectorAll('.ticker__link');

// adds links to fill window width
const addLinks = () => {
  const itemsWidth = items.offsetWidth;
  const doubleWidth = (window.innerWidth * 2);
  let i;

  for (i = items.offsetWidth; i < (window.innerWidth * 2); i = items.offsetWidth) {
    links.forEach(link => {
      if ((window.innerWidth * 2) <= items.offsetWidth) {
        return false;
      }

      $(items).append(link.outerHTML);
    });
  }

  $(items).addClass('animate');
};

// called from _resize.js + _orientation.js
export const handleTicker = () => {
  if ($(items).length > 0) {
    $(items).html('').removeClass('animate');
    addLinks();
  }
};

// prevent calling if ticker doesn't exist on page
if ($(items).length > 0) {
  addLinks();
}
